import { Card } from '@/components_deprecated/Card'
import type { ApproveWorkPeriodNode } from '@/modules/salary/types.graphql'
import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useState } from 'react'
import { ApprovalCommentDayGroup } from './ApprovalCommentDayGroup'
import { ApprovalCommentsHeader } from './ApprovalCommentsHeader'
import type { Role } from './types'
import { useApprovalCommentEntries } from './useApprovalCommentEntries'

interface Props {
  workPeriods: Pick<
    ApproveWorkPeriodNode,
    | 'id'
    | 'user'
    | 'leaderGroup'
    | 'datetimeStart'
    | 'datetimeEnd'
    | 'userComment'
    | 'managerComment'
    | 'userApprover'
    | 'managerApprover'
  >[]
}

export const ApprovalCommentsList: React.FC<Props> = ({ workPeriods }) => {
  const t = useTranslate({
    title: 'salary.approval-comments',
    empty: 'salary.no-approval-comments',
  })

  const [roleFilter, setRoleFilter] = useState<Role | null>(null)

  const groups = useApprovalCommentEntries({ workPeriods, roleFilter })

  return (
    <Card className="mt-4 overflow-hidden" $padding="0">
      <ApprovalCommentsHeader
        title={t.title}
        roleFilter={roleFilter}
        onRoleFilterChange={setRoleFilter}
      />

      {groups.length === 0 ? (
        <div className="px-6 py-10 text-center text-sm text-[#767689]">
          {t.empty}
        </div>
      ) : (
        groups.map(group => (
          <ApprovalCommentDayGroup key={group.key} group={group} />
        ))
      )}
    </Card>
  )
}
